Ext.define('SA.Storage', {
    singleton: true,

    addListener(listener) {
        window.addEventListener('storage', listener);

        return {remove: () => window.removeEventListener('storage', listener)};
    },

    clear() {
        SA.SessionStorage.clear();
        SA.LocalStorage.clear();
    }
});